module.exports = __webpack_public_path__ + "img/DK63370215.f408aa1c.png";